import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Vehicles from './pages/Vehicles';
import ServiceRequests from './pages/ServiceRequests';
import Profile from './pages/Profile';
import Partners from './pages/Partners';
import Notifications from './pages/Notifications';
import AppConfig from './pages/AppConfig';
import Challan from './pages/Challan';
import VehicleSearched from './pages/VehicleSearched';
import ChallanSearched from './pages/ChallanSearched';
import AdminManagement from './pages/AdminManagement';
import DashboardOverview from './pages/DashboardOverview';
import ErrorBoundary from './components/ErrorBoundary';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>;
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function AppContent() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardOverview />} />
        <Route path="users" element={<Users />} />
        <Route path="vehicles" element={<Vehicles />} />
        <Route path="service-requests" element={<ServiceRequests />} />
        <Route path="profile" element={<Profile />} />
        <Route path="partner" element={<Partners />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="config" element={<AppConfig />} />
        <Route path="challan" element={<Challan />} />
        <Route path="search" element={<VehicleSearched />} />
        <Route path="search-challans" element={<ChallanSearched />} />
        <Route path="admin-management" element={<AdminManagement />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <ErrorBoundary>
          <AppContent />
        </ErrorBoundary>
      </AuthProvider>
    </Router>
  );
}

export default App;